import { motion } from "framer-motion";
import React, { useState } from "react";
import Swal from "sweetalert2";

const Contact = () => {
  const [formData, setFormData] = useState({
    Name: "",
    Phone: "",
    Email: "",
    Subject: "",
    Message: ""
  });
  const apiUrl = process.env.REACT_APP_GOOGLE_SHEET_URL ?? "";
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const linkStyle = "text-black font-semibold font-montserrat px-3 py-2 rounded hover:bg-[#153f85] hover:text-[#ffffff]";

  // Update state saat input berubah
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Submit data ke Google Apps Script
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);

    try {
     await fetch(
      apiUrl,
      {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
        },
         mode: "no-cors"
      }
    );
    // Clear form
    setFormData({
      Name: "",
      Phone: "",
      Email: "",
      Subject: "",
      Message: "",
    });
    // Clear cache (localStorage & sessionStorage)
    localStorage.clear();
    sessionStorage.clear();

    // Tampilkan popup sukses
    Swal.fire({
      icon: "success",
      title: "Berhasil!",
      text: "Pesan Anda sudah terkirim.",
      showConfirmButton: false,
      timer: 3000, // auto close 3 detik
    });

    setSuccess(true);

    
    } catch (error) {
       console.error("Error:", error);
    }  finally {
    setLoading(false);
  }
  };

  return (
    <div className="flex flex-col items-center justify-center md:w-full">
      <div>
        <motion.div
          className="w-full sm:w-full mb-8"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }} // animasi saat masuk viewport
          // animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.2 }} // jalan berulang, trigger saat 20% terlihat
        >
          <h3 className="text-5xl sm:text-5xl md:text-6xl font-extrabold bg-gradient-to-r from-blue-500 via-indigo-600 to-purple-700 text-center bg-clip-text text-transparent">
            Contact Us
          </h3>
        </motion.div>

        <motion.div
          className="w-full sm:w-full mb-8"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }} // animasi saat masuk viewport
          // animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          viewport={{ once: false, amount: 0.2 }} // jalan berulang, trigger saat 20% terlihat
        >
          <form
            onSubmit={handleSubmit}
            className="p-4 rounded-lg shadow-lg bg-[#fafafa] min-w-[300px] max-w-[350px] md:min-w-[750px] md:max-w-[900px] lg:min-w-[901px] lg:max-w-[1000px]"
          >
            {/* sm:max-w-[600px] md:max-w-[900px] md:min-w-[750px] lg:max-w-[1200px] */}
            <div className="  h-auto flex flex-col md:flex-row sm:flex-col   gap-8">
              {/* Kolom Kiri */}
              <div className="w-full sm:w-full md:w-1/2 flex flex-col gap-4">
                <div>
                  <label htmlFor="Name" className={linkStyle}>Name</label>
                  <input
                    type="text"
                    name="Name"
                    id="Name"
                    value={formData.Name}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div>
                  <label htmlFor="Phone" className={linkStyle}>Phone</label>
                  <input
                    type="text"
                    name="Phone"
                    id="Phone"
                    value={formData.Phone}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div>
                  <label htmlFor="Email" className={linkStyle}>Email</label>
                  <input
                    type="email"
                    name="Email"
                    id="Email"
                    value={formData.Email}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
              </div>

              {/* Kolom Kanan */}
              <div className="w-full sm:w-full md:w-1/2 flex flex-col gap-4">
                <div>
                  <label htmlFor="Subject" className={linkStyle}>Subject</label>
                  <input
                    type="text"
                    name="Subject"
                    id="Subject"
                    value={formData.Subject}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  />
                </div>
                <div>
                  <label htmlFor="Message" className={linkStyle}>Message</label>
                  <textarea
                    name="Message"
                    value={formData.Message}
                    onChange={handleChange}
                    required
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md"
                  ></textarea>
                </div>
              </div>
            </div>

            <div className="mt-6">
              <button
                type="submit"
                disabled={loading}
                className={`w-full ${
                  loading ? "bg-gray-400" : "bg-blue-600 hover:bg-blue-700"
                } text-white font-semibold py-2 px-4 rounded-md shadow-md transition duration-200`}
              >
                {loading ? "Sending..." : "Submit"}
              </button>

              {success && (
                <p className="mt-3 text-green-600 font-medium">
                  ✅ Message sent successfully!
                </p>
              )}
            </div>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;